<script lang="ts">
  // administrator start
  // buttons lead to:
  // 1) slt admin
  // 2) pwa admin (may further go to pwa results)
  // 3) own training session
  // 4) own results

  import { auth } from "../firebase";

  import { Pages, Role } from "../enums";

  import { route } from "../stores/route.svelte";
  import { loggedIn, user, center } from "../stores/user-store.svelte";

  import { Icons } from "../utilities/icons";

  import YesNoModal from "../modals/YesNoModal.svelte";

  import IconButton from "../components/IconButton.svelte";

  // STATE -------------------------------------------------

  let showYesNoModal = $state(false);

  // FUNCTIONS ---------------------------------------------

  const editCenterClicked = () => {
    route.current = Pages.CenterEdit;
  };

  const editPrivateClicked = () => {
    route.current = Pages.PrivateEdit;
  };

  const editSLTClicked = () => {
    route.current = Pages.SLTEdit;
  };

  const editPWAClicked = () => {
    route.current = Pages.PWAEdit;
  };

  const doLogOut = () => {
    auth.signOut().then(function () {
      localStorage.setItem("rememberMeOnThisDevice", "no");
      loggedIn.value = false;
      route.current = Pages.Login;
    });
  };

  const logOutClicked = () => {
    showYesNoModal = true;
  };
</script>

<!-- HTML ===================================================== -->

<main data-page="admin-start">
  <div class="headline">
    <h1>MODAK - Administrator</h1>
    <h2>{user.value.name} - {center.value.name}</h2>
  </div>
  {#if user.value.role === Role.Super}
    <IconButton
      fat={true}
      mediumWide={true}
      textLargeScaled={true}
      icon={Icons.EditRegular}
      onclick={editCenterClicked}
    >
      {#snippet message()}Centre{/snippet}
    </IconButton>
    <IconButton
      fat={true}
      mediumWide={true}
      textLargeScaled={true}
      icon={Icons.EditRegular}
      onclick={editPrivateClicked}
    >
      {#snippet message()}Private{/snippet}
    </IconButton>
  {/if}
  <IconButton
    fat={true}
    mediumWide={true}
    textLargeScaled={true}
    icon={Icons.EditRegular}
    onclick={editSLTClicked}
  >
    {#snippet message()}Logopæder{/snippet}
  </IconButton>

  <IconButton
    fat={true}
    mediumWide={true}
    textLargeScaled={true}
    icon={Icons.EditRegular}
    onclick={editPWAClicked}
  >
    {#snippet message()}Borgere{/snippet}
  </IconButton>

  <IconButton
    textMediumScaled={true}
    icon={Icons.SignOutAlt}
    onclick={logOutClicked}
  >
    {#snippet message()}Log ud{/snippet}
  </IconButton>
</main>

{#if showYesNoModal}
  <YesNoModal no={() => (showYesNoModal = false)} yes={doLogOut}
    >{#snippet message()}Vil du logge ud?{/snippet}</YesNoModal
  >
{/if}

<!-- CSS ====================================================== -->
<style>
  main {
    height: calc(var(--vh, 1vh) * 100);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 4vmin;
  }
  h1 {
    font-size: 6vmin;
    font-weight: bold;
    padding-bottom: 1vmin;
  }
  h2 {
    font-size: 3vmin;
    font-weight: bold;
  }
  .headline {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
</style>
